class GalleryController {
  /* @ngInject */
  constructor($log, files, data) {
    angular.merge(this, data);
    Object.assign(this, {
      $log,
      files,
      rotation: 0
    });
  }

  getCurrentFile() {
    return this.files[this.index];
  }

  isCurrentFile(index) {
    return this.index === index;
  }

  setStatus(status) {
    this.getCurrentFile().rejected = status;
  }
  /*
  =============================================================================
  Gallery Actions
  =============================================================================
  */


  next() {
    if (++this.index >= this.files.length) {
      this.index = 0;
    }

    if (!this.getCurrentFile().file_id) {
      // this.next();
    }
  }

  previous() {
    if (--this.index < 0) {
      this.index = this.files.length - 1;
    }

    if (!this.getCurrentFile().file_id || !this.getCurrentFile().file.id) {
      // this.previous();
    }
  }

  rotate() {
    this.rotation += 90;
    let gallery = $('.image-gallery'),
        image = $(`#gallery-img${this.index}`),
        imageWidth = image.width(),
        galleryHeight = gallery.height(),
        maxHeight; // Check if image is landscape or portrait

    if (image.width() > image.height()) {
      if (imageWidth > galleryHeight) {
        maxHeight = galleryHeight;
      }
    }

    gallery.css({
      height: `${maxHeight}px`
    });
    image.css({
      width: `${maxHeight}px`,
      transform: `rotate(${this.rotation}deg)`
    });
  }

}

GalleryController.$inject = ["$log", "files", "data"];
angular.module('pims').controller('GalleryController', GalleryController);
